import React from "react";
import {
  isQuestionMsgStepId,
  PersonalizationValue,
  TriggerStepCreate,
} from "@dots-projects/types";
import { useForm } from "react-hook-form";
import produce from "immer";
import { saveDraft, updateStep } from "./reducer/actionCreators";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import invariant from "ts-invariant";
import { StepFormWithCommonParts } from "./TriggerStepForm";
import { FormLabel } from "./FormLabel";
import { TriggerEditorVariablesSelector } from "./TriggerEditorVariablesSelector";

/**
 * Renders the form for a "Change Nickname step"
 */
export function StepFormChangeNickname({
  step,
  insertVariables,
}: {
  step: TriggerStepCreate;
  insertVariables: PersonalizationValue[];
}) {
  invariant(step.type === "change_nickname");

  const defaultValues = {
    name: step.name,
    nickname: step.configs.nickname,
  };

  const form = useForm({
    defaultValues,
  });
  const { handleSubmit, control, setValue } = form;
  const { dispatch, onPersist, state } = useTriggerEditorStateDispatch();
  const readOnly = !state.trigger.current.isDraft;

  const onSubmit = (data: any) => {
    // This uses the immer library to create a new copy of step (with updates)
    // without affecting the original step.
    const newStep = produce(step, (stepDraft) => {
      stepDraft.name = data.name;
      stepDraft.configs.userId = "{{user.id}}";
      stepDraft.configs.nickname = data.nickname
        ? `{{${data.nickname.replaceAll(/{|}/g, "")}}}`
        : "";
    });
    dispatch(updateStep(newStep));
    dispatch(saveDraft(onPersist));
  };

  return (
    <StepFormWithCommonParts
      onSubmit={handleSubmit(onSubmit)}
      form={form}
      step={step}
      customTitle={isQuestionMsgStepId(step.id) ? "Send a question" : undefined}
    >
      <FormLabel label="What nickname will you want to give" />
      <TriggerEditorVariablesSelector
        triggerVariables={insertVariables}
        defaultValue={defaultValues.nickname}
        control={control}
        readOnly={readOnly}
        fieldName={"nickname"}
        placeholder={"What nickname will you want to give"}
      />
    </StepFormWithCommonParts>
  );
}
